/**
 * `app` module
 * Provides the game initialization routine.
 */

// Required: import the Babel runtime module.
import 'babel-polyfill'

// Import game states.
import * as stats from './stats'
import * as params from './params'
import * as states from './states'
import * as audio from './audio'

export function init() {
    var config = {
        width: 640,
        height: 480,
        renderer: Phaser.AUTO,
        antialias: true
    };

    const game = new Phaser.Game(config);

    // Hack for Phaser fonts
    Phaser.Cache.addBitmapFontFromAtlas = function (key, atlasKey, atlasFrame, dataKey, dataType, xSpacing, ySpacing) {

        var frame = this.getFrameByName(atlasKey, atlasFrame);

        if (!frame) {
            return;
        }

        var obj = {
            font: null,
            base: this.getBaseTexture(atlasKey),
            frame: frame
        };

        if (xSpacing === undefined) {
            xSpacing = 0;
        }
        if (ySpacing === undefined) {
            ySpacing = 0;
        }

        var fontData;

        if (dataType === 'json') {
            fontData = this.getJSON(dataKey);
            obj.font = Phaser.LoaderParser.jsonBitmapFont(fontData, obj.base, xSpacing, ySpacing, frame);
        }
        else {
            fontData = this.getXML(dataKey);
            obj.font = Phaser.LoaderParser.xmlBitmapFont(fontData, obj.base, xSpacing, ySpacing, frame);
        }

        for (var charName in obj.font.chars) {
            var char = obj.font.chars[charName];
            //console.log("char before: ", char);
            char.x -= 20;
            char.y -= 20;

            char.width += 40;
            char.height += 40;

            char.corrected = true;
            //console.log("char after: ", char);
        }

        this._cache.bitmapFont[key] = obj;

    };
    Phaser.LoaderParser.xmlBitmapFont = function (xml, baseTexture, xSpacing, ySpacing, frame) {
        var fixForFonts = 2;

        var data = {};
        var info = xml.getElementsByTagName('info')[0];
        var common = xml.getElementsByTagName('common')[0];

        data.font = info.getAttribute('face');
        data.size = parseInt(info.getAttribute('size'), 10);
        data.lineHeight = parseInt(common.getAttribute('lineHeight'), 10) + ySpacing;
        data.chars = {};

        var letters = xml.getElementsByTagName('char');

        var x = (frame) ? frame.x : 0;
        var y = (frame) ? frame.y : 0;

        for (var i = 0; i < letters.length; i++) {
            var charCode = parseInt(letters[i].getAttribute('id'), 10);

            data.chars[charCode] = {
                x: x + parseInt(letters[i].getAttribute('x'), 10) - fixForFonts,
                y: y + parseInt(letters[i].getAttribute('y'), 10) - fixForFonts,
                width: parseInt(letters[i].getAttribute('width'), 10) + 2 * fixForFonts,
                height: parseInt(letters[i].getAttribute('height'), 10) + 2 * fixForFonts,
                xOffset: parseInt(letters[i].getAttribute('xoffset'), 10),
                yOffset: parseInt(letters[i].getAttribute('yoffset'), 10),
                xAdvance: parseInt(letters[i].getAttribute('xadvance'), 10) + xSpacing,
                kerning: {}
            }
        }

        var kernings = xml.getElementsByTagName('kerning');

        for (i = 0; i < kernings.length; i++) {
            var first = parseInt(kernings[i].getAttribute('first'), 10);
            var second = parseInt(kernings[i].getAttribute('second'), 10);
            var amount = parseInt(kernings[i].getAttribute('amount'), 10);

            data.chars[second].kerning[first] = amount
        }

        return this.finalizeBitmapFont(baseTexture, data)
    };

    // Dynamically add all required game states.
    Object
        .entries(states)
        .forEach(([key, state]) => game.state.add(key, state))

    game.state.start('Boot');

    return game
};
